export default __webpack_public_path__ + "static/media/satisfactory.019eecc1.svg";